import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-JointTenancy',
    templateUrl: './JointTenancy.component.html',
    styleUrls: ['./JointTenancy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JointTenancyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
